<template>
  	<div class="animated fadeIn bgV2">
    	<b-row>
      		<b-col md="12">
        		<gofix-tab
            		class="mt-3 ContractCaseSettings"
            		:data="contract_tab"
					:query-param="{id:$route.params.id}"
					activeKey="maintenance-settings"
            		arrows >
          			<template slot="gofixTab:maintenance-settings">
						<gofix-card classContent="mb-0" title=" ">
							<b-row align-v="center">
								<b-col md="6">
									<gofix-form-dropdown
										label="Email To"
										v-model="setting.emails"
										:options="[]"
										:filterable="false"
										taggable
										pushTags
										multiple
										noDrop>
									</gofix-form-dropdown>
								</b-col>
								<b-col md="6" class="text-right">
									<gofix-button @click="saveData" :loading="loadingSave" label="Save"></gofix-button>
								</b-col>
							</b-row>
						</gofix-card>
						<gofix-card class="mb-0" fullContent>
							<gofix-table
								:settings="tableConfig"
								:table-items="tableItems"
								@load-items="getTableData"
								@new-item="openCreateModal"
								@row-click="openEditModal"
								@delete-items="deleteItems"
								ref="gofixTable">
								<template slot="gofix_table:id" slot-scope="row">
									{{ row.index + 1 }}
								</template>
								<template slot="gofix_table:is_send_daily" slot-scope="row">
									{{ row.item.is_send_daily == true ? 'Yes' : 'No' }}
								</template>
							</gofix-table>
						</gofix-card>
          			</template>
        		</gofix-tab>
      		</b-col>
    	</b-row>
    	<b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.title" hide-footer :centered="true" v-model="modals.open">
      		<b-form class="">
        		<b-row>
          			<b-col md="12">
						<gofix-form-dropdown label="Priority"
							v-bind:class="{'run-loading small-loading': loadingPriority}"
							v-model="modals.priority"
							:clearable="false"
							:options="modals.prioritys">
						</gofix-form-dropdown>
					</b-col>
					<b-col md="12" class="mb-2">
						<gofix-form-input-number label="Exceed Time"
							v-model="modals.exceed_time"
							required
							desc="hours"
							:integer-limit="15"
							:include-thousands-separator="false"
							:allowDecimal="false">
						</gofix-form-input-number>
          			</b-col>
					<b-col md="12" class="pl-25">
						<b-form-checkbox v-model="modals.is_send_daily"><span class="ml-2">Send Daily</span></b-form-checkbox>
					</b-col>
        		</b-row>
			</b-form>
			<b-button-group class="d-block text-right" >
				<gofix-button label="SUBMIT" :loading="modals.loading" noBorder @click="save"></gofix-button>
			</b-button-group>
		</b-modal>
	</div>
</template>
<script>
import tabData from '@/data/_tabs';
import { mapGetters, mapActions } from 'vuex';

export default {
  	name: 'contract-maintenance-settings',
  	data () {
    	return {
			contract_tab: tabData.client_contract,
			tableItems: [],
			tableConfig:{
				name: 'maintenance-settings',
				controls: { },
				filter: { 
					contract_id: { type: 'number', value: null, function: '=', with: [] },
					exceed_time: { type: 'number', value: null, function: '=', with: [] },
					priority:    { type: 'text', value: null, function: 'ilike', with: [] }
				},
				page: 1,
				limit: 100,
				sortColumn: "id",
				sortDirection: "asc",
				fields: [
                    {
                        key: 'actions',
                        label: '',
                        thClass: 'checkbox-column text-center',
                        tdClass: 'checkbox-column text-center',
                        width: 50,
                        thStyle: "width:50px",
                    },
                    {
                        key: 'id',
                        label: 'No.',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width:100px",
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
					{
                        key: 'priority',
                        label: 'Priority',
                        isActive: 1,
                        isFilter: true,
                        sorting: true,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'exceed_time',
                        label: 'Exceed Time (hours)',
                        isActive: 1,
                        isFilter: true,
                        sorting: true,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'is_send_daily',
                        label: 'Send Daily',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'auto',
                        label: '',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                ]
			},
			modals:{
				title: 'Create new',
				loading: false,
				open: false,
				id: null,
				priority: null,
				prioritys: [],
				exceed_time: 0,
				is_send_daily: false,
			},
			loadingPriority: false,
			setting: {
				emails: [],
			},
			loadingSave: false,
			timer: null
		}
	},
	components: {
		
	},
  	created() {
		if(this.ClientContractID && this.ClientContractID.maintenance_settings) {
			this.setting = Object.assign(this.setting, this.ClientContractID.maintenance_settings);
		}
	},
 	filters: {
		
	},
  	watch: {
		ClientContractID: function(val) {
			this.modals.priority = null
			this.modals.exceed_time = 0
			this.modals.is_send_daily = false
            this.$refs.gofixTable.reloadTableItems()
			if(val && val.settings) {
				this.setting = Object.assign(this.setting, val.maintenance_settings);
			} else {
				this.setting = {
					emails: []
				}
			}
        }
  	},
  	computed: {
    	...mapGetters({})
  	},
  	methods: {
		async getTableData(callback){
			const { tableRequest , resolve,reject } = await callback();
      		tableRequest.filter.contract_id = { type: 'number', value: this.$route.params.id, function: '=', with: [] };
      		await this.$store.dispatch("MaintenanceSettingsController/getItems", tableRequest)
          	.then(response => {
				this.tableItems = response.items;
				this.tableConfig.total = response.total;
				resolve(response);
          	})
          	.catch(err => {
            	this.$alertNotification("Can not load the data", "danger");
            	reject();
         	 })
		},
		save(){
			this.modals.loading = true

			if(!this.modals.priority){
				return this.$alertNotification('Please enter Priority', 'danger')
			}

			if(!this.modals.exceed_time){
				return this.$alertNotification('Please enter Exceed Time', 'danger')
			}
			
			if(!this.modals.is_send_daily){
				this.modals.is_send_daily = false
			}

			let dataSubmit = {
				'priority': this.modals.priority,
				'contract_id': this.$route.params.id,
				'exceed_time': this.modals.exceed_time,
				'is_send_daily': this.modals.is_send_daily
			}

			if(this.modals.id){

				dataSubmit.id = this.modals.id

				this.$store.dispatch("MaintenanceSettingsController/updateItem", dataSubmit)
				.then(response => {
					this.modals.open = false
					this.modals.loading = false
					this.$refs.gofixTable.reloadTableItems()
					this.$alertNotification('Successfully updated', 'success')

					this.modals.priority = null
					this.modals.exceed_time = 0
					this.modals.is_send_daily = false
					this.modals.id = null
					alertNotification(this.$notificationV2('adding', 'operating_hour'));
				})
				.catch(err => {
					if (err.response.data.error && err.response.data.error.message) {
						this.$alertNotification(err.response.data.error.message, "danger")
					}
					this.modals.open = false
					this.modals.loading = false
				});
			}else{
				this.$store.dispatch("MaintenanceSettingsController/saveItem", dataSubmit)
				.then(response => {
					this.modals.open = false
					this.modals.loading = false
					this.$refs.gofixTable.reloadTableItems()
					this.$alertNotification('Successfully added', 'success')

					this.modals.priority = null
					this.modals.exceed_time = 0
					this.modals.is_send_daily = false
				})
				.catch(err => {
					if (err.response.data.error && err.response.data.error.message) {
						this.$alertNotification(err.response.data.error.message, "danger")
					}
					this.modals.open = false
					this.modals.loading = false
				});
			}
		},
		async deleteItems(callback){
			const { ids,filter, resolve,reject } = await callback();
			await this.$store.dispatch('MaintenanceSettingsController/deleteItems', ids)
			.then(response => {
				this.$alertNotification('Successfully deleted', 'success')
				resolve(response);
			})
			.catch(err => {
				reject();
			})
		},
		openCreateModal(){
			this.modals.id = null
			this.modals.priority = null
			this.modals.exceed_time = 0
			this.modals.is_send_daily = false
			this.modals.title = 'Add New Maintenance Settings'
			this.modals.open = true
			this.getPrioritySet()
		},
		openEditModal(item){
			this.modals.title = 'Edit Maintenance Settings'

			this.modals.id = item.id
			this.modals.priority = item.priority
			this.modals.exceed_time = item.exceed_time
			this.modals.is_send_daily = item.is_send_daily
			
			this.getPrioritySet()
			
			this.modals.open = true
		},
		getPrioritySet() {
			this.loadingPriority = true
			this.$store.dispatch('v2PrioritySetController/getPrioritySet', {
				contract_id: this.$route.params.id
			})
			.then(response => {
				this.modals.prioritys = Object.values(response.priority_options)
				this.loadingPriority = false
			})
			.catch(err => {
				this.loadingPriority = false
			});
		},
		emailValidationCheckFormat(email_address){
            if(email_address && email_address != ''){
                let pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                let result = pattern.test(email_address);
                return result;
            }
            return true;
        },
		saveData() {
			if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
					let filters = this.setting.emails.filter(item => {
						if(!this.emailValidationCheckFormat(item)) return item
					})
					if(filters.length) return this.$alertNotification('Invalid email', 'danger');
                    this.loadingSave = true;
                    let objClone = {
                        contract_id: this.ClientContractID.id,
                        client_id: this.ClientContractID.client_id,
                        supplier_id: this.ClientContractID.supplier_id,
                        contract_name: this.ClientContractID.contract_name,
                        abbreviation: this.ClientContractID.abbreviation,
                        description: this.ClientContractID.description,
                        deposit_amount: this.ClientContractID.deposit_amount,
                        issuing_bank: this.ClientContractID.issuing_bank,
                        deposit_expiry: this.ClientContractID.deposit_expiry,
                        insurance_expiry: this.ClientContractID.insurance_expiry,
                        insurance_excess: this.ClientContractID.insurance_excess,
                        insurance_type: this.ClientContractID.insurance_type,
                        timezone: this.ClientContractID.timezone,
						settings: this.ClientContractID.settings,
                        case_settings: this.ClientContractID.case_settings,
						maintenance_settings: this.setting
                    }

                    objClone.settings = JSON.stringify(objClone.settings);
                    objClone.case_settings = JSON.stringify(objClone.case_settings);
					objClone.maintenance_settings = JSON.stringify(objClone.maintenance_settings);
                    this.$store.dispatch('ContractController/UpdateClientContract', objClone)
                    .then(response => {
                        this.loadingSave = false;
                        this.$store.dispatch('ContractController/getClientContractID', objClone.contract_id);
                        this.$alertNotification(this.$notificationV2('editing', 'client_contract_setting'));
                    })
                    .catch(error => {
                        this.loadingSave = false;
                    });
                }, 100);
		}
	},
}
</script>
